import localforage from 'localforage';

const STORAGE_KEY = 'APP_DEVICE_ID';

// UUID 生成
function generateUUID(): string {
  return (
    crypto?.randomUUID?.() ||
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
  );
}

// cookie 操作
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}
function setCookie(name: string, value: string, days = 365) {
  const expires = new Date(Date.now() + days * 86400 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
}

// 获取设备 ID（优先级：IndexedDB > localStorage > cookie）
export async function getDeviceId(): Promise<string> {
  let deviceId = await localforage.getItem<string>(STORAGE_KEY);

  if (!deviceId) {
    deviceId = localStorage.getItem(STORAGE_KEY) || getCookie(STORAGE_KEY);
  }

  if (!deviceId) {
    deviceId = generateUUID();
    await localforage.setItem(STORAGE_KEY, deviceId);
    localStorage.setItem(STORAGE_KEY, deviceId);
    setCookie(STORAGE_KEY, deviceId);
  }

  return deviceId;
}
